import { FC } from 'react'
import { useParams } from 'react-router-dom'
import useQueryPlayerById from '../../hooks/useQueryPlayerById'
import { PlayerFinancialHistoryTable } from '../index'

const PlayerFinancialHistory: FC = () => {
  const { playerId } = useParams()

  const { data: player } = useQueryPlayerById(playerId as string)

  if (!player) return null

  return <PlayerFinancialHistoryTable id={player.id} login={player.login} currency={player.currency} />
}

export default PlayerFinancialHistory
